(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-img"] = factory(require("mggp-player"));
	else
		root["mggp-vendor-img"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-vendor-img.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-vendor-img.js":
/*!********************************!*\
  !*** ./src/mggp-vendor-img.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by User on 06/04/2016.
 */


var MggpVendor = __webpack_require__(/*! mggp-player */ "mggp-player").Vendor;
var AddonError = __webpack_require__(/*! mggp-player */ "mggp-player").AddonError;

function MggpVendorImg(player, config) {
	MggpVendor.apply(this, arguments);

	var self = this;

	var _src = null;
	var _options = null;
	var _currentTime = 0;
	var _image = null;
	var _playing = false;
	var _prevTime = -1;
	var _duration = 0;
	var _beforeCompleteFired = false;
	var _autoPlay = true;
	var _imgLoaded = false;

	this.emit('vendorCreate');
	this.player.utils.log('MggpVendorImg created');

	this.dispose = function () {
		_toggleListeners(false);
		var parentNode = _image ? _image.parentNode : null;
		if (parentNode) {
			parentNode.removeChild(_image);
		}
		_src = null;
		_options = null;
		_currentTime = 0;
		_image = null;
		_playing = false;
		_imgLoaded = false;
		_prevTime = -1;
		_duration = 0;
		_beforeCompleteFired = false;
		_autoPlay = true;
		self.namespase = null;
		self.config = null;

		self.emit('vendorDestroy');
		self.player.utils.log('MggpVendorImg.dispose');
	};

	this.load = function (src, videoInfo, options) {
		_currentTime = 0;
		_playing = false;
		_imgLoaded = false;
		_prevTime = -1;
		_duration = 0;
		_autoPlay = true;
		_beforeCompleteFired = false;

		if (options) {
			_options = options;
			self.checkOptions(options);
			if (options.duration) {
				_duration = options.duration;
				self.set('duration', _duration);
			}
			if ('autoplay' in options && options['autoplay'] === false) {
				_autoPlay = false;
			}
		}
		if (src) {
			_src = src;
		}
		_setState(-1);
		_createIMGTag();
		_setState(3);
		_image.src = _src;
	};

	this.play = function () {
		if (!_playing && _imgLoaded) {
			_prevTime = new Date().getTime() / 1000;
			_playing = true;
			_setState(1);
		}
	};

	this.pause = function () {
		if (_playing) {
			_playing = false;
			_setState(2);
		}
	};

	this.stop = function () {
		self.dispose();
	};

	this.togglePlayPause = function () {
		if (_playing) {
			self.pause();
		} else {
			self.play();
		}
	};

	this.seekTo = function (time) {
		self.emit('mediaSeekStart');
		if (time > _duration) {
			time = _duration;
		} else if (time < 0) {
			time = 0;
		}
		_currentTime = time;
		self.emit('mediaSeekEnd');
	};

	this.setVolume = function (volume) {
		self.set('volume', volume);
	};

	this.mute = function () {
		self.set('muted', true);
	};

	this.unMute = function () {
		self.set('muted', false);
	};

	this.getPlayableElement = function () {
		return _image;
	};

	//privates
	var _setState = function _setState(newState) {
		self.set('state', newState);
		self.emit('stateChange', newState);
	};

	var _createIMGTag = function _createIMGTag() {
		if (!_image) {
			_image = document.createElement('img');
			_image.setAttribute("data-adl-consent", "ignore");
			_image.className = self.namespace + 'img' + ' vendor';
			if (_options.width) {
				_image.style.width = self.options.width;
			}
			if (_options.height) {
				_image.style.height = self.options.height;
			}
			// _image.style.position = 'absolute';
			_image.style.visibility = 'hidden';

			_image.style.maxWidth = '100%';
			_image.style.maxHeight = '100%';
			_image.style.display = 'block';
			_image.style.margin = 'auto';

			self.container.appendChild(_image);
			_toggleListeners(true);
		}
	};

	var _toggleListeners = function _toggleListeners(toggleOn) {
		if (toggleOn) {
			self.player.on('player:timeUpdate', _onTimeUpdate);
			if (_image) {
				_image.addEventListener('error', _onImgEvent, false);
				_image.addEventListener('load', _onImgEvent, false);
			}
		} else {
			self.player.off('player:timeUpdate', _onTimeUpdate);
			if (_image) {
				_image.removeEventListener('error', _onImgEvent, false);
				_image.removeEventListener('load', _onImgEvent, false);
			}
		}
	};

	var _onTimeUpdate = function _onTimeUpdate(event) {
		if (_playing) {
			var nowTime = new Date().getTime() / 1000;
			_currentTime += nowTime - _prevTime;
			_prevTime = nowTime;
			self.set('position', _currentTime);

			if (_duration - _currentTime < 1 && !_beforeCompleteFired) {
				_beforeCompleteFired = true;
				self.emit("mediaBeforeComplete");
			}

			if (_currentTime >= _duration) {
				_currentTime = _duration;
				_setState(0);
				_toggleListeners(false);
			}
		}
	};

	var _onImgEvent = function _onImgEvent(event) {
		switch (event.type) {
			case 'error':
				self.emit('mediaError');
				_setState(5);

				if (AddonError) {
					var errorType, errorCode, errorMessage;
					errorType = AddonError.errorTypes.NETWORK_ERROR;
					errorCode = AddonError.errorCodes[errorType].MEDIA_FILE_LOADING_ERROR;
					var src = _image ? _image.src : '';
					errorMessage = AddonError.errorMessages[errorCode] + ' ' + src;
					new AddonError(self.player, errorType, errorCode, errorMessage, false);
				}

				break;
			case 'load':
				_imgLoaded = true;
				_image.style.visibility = 'visible';
				self.emit('mediaCanPlay');
				self.emit('loadedFraction', 1);
				if (_autoPlay) {
					self.play();
				} else {
					_setState(5);
				}
				break;
		}
	};
}

MggpVendorImg.prototype = Object.create(MggpVendor.prototype);
MggpVendorImg.prototype.constructor = MggpVendorImg;

MggpVendorImg.mimeTypes = ['gif', 'jpeg', 'png', 'jpg'];
MggpVendorImg.priority = 0;

MggpVendorImg.canPlay = function (type) {
	return MggpVendorImg.mimeTypes.indexOf(type) != -1;
};

module.exports = MggpVendorImg;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});